import React from 'react';
import { useWatch } from 'react-hook-form';
import { RhNumberField } from '../../../../../../../../dum';
import { IOrderQuotation } from '../../../order-quotation-form';
import { useCalculateProductsTotal } from '../../../helpers/use-calculate-products-total';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../../helpers';

const ARRAY_NAME: keyof IOrderQuotation = 'order_quotation_products';
const KILOS_FIELD_NAME: keyof IOrderQuotation['order_quotation_products'][number] =
    'kilos';
const GROUP_WEIGHT_FIELD_NAME: keyof IOrderQuotation['order_quotation_products'][number] =
    'group_weight';

interface IKilosInputProps {
    index: number;
}

export function KilosInput({ index }: IKilosInputProps) {
    const INPUT_NAME = `${ARRAY_NAME}.${index}.${KILOS_FIELD_NAME}`;
    // When a group_weight is set (linked line, or a free line where it was
    // typed), kilos is derived as groups × group_weight and locked — matching
    // the backend rule groups × group_weight === kilos.
    const groupWeightValue = useWatch({
        name: `${ARRAY_NAME}.${index}.${GROUP_WEIGHT_FIELD_NAME}`,
    });

    const { calculateProductsTotal } = useCalculateProductsTotal();

    return (
        <RhNumberField
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.kilos)}
            disableGutters
            disabled={!!groupWeightValue}
            onChange={() => {
                calculateProductsTotal();
            }}
        />
    );
}
